import { db } from "common/config/Firebase"

const ticketsCollection = db.collection('tickets')

const findTicketByIdUseCase = async ({ id }) => {
    const data = await ticketsCollection.doc(id).get()

    return data.data()
}

export default findTicketByIdUseCase